import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './MobileMenuLink.css';
import lowerCaseFirstLetter from '../../common/lowerCaseFirstLetter';
import logComponent from '../../common/logComponent';

export default function MobileMenuLink({ showFocus: propsShowFocus, onSelect, linkPath, linkPopup, user, permittedUsers, showReports, linkText, linkIcon, linkAncestors, subLinks, level,  stagedOrganizationCount, messageCount,  lastReload }) {
  const [expanded, setExpanded] = useState(false);
  const [showFocus, setShowFocus] = useState(false);
  const [focusedByMouse, setFocusedByMouse] = useState(false);
  const isLink = !(subLinks && subLinks.length > 0)
  const outerLiKey = linkPath + '_link';
  const buttonRef = useRef(null);

  if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink rendered'); }

  const setButtonRef = el => buttonRef.current = el;

  useEffect(() => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink useEffect [propsShowFocus]'); }
    setShowFocus(propsShowFocus);
  }, [propsShowFocus])

  const select = (e) => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink select'); }
    onSelect(linkPath, linkPopup);
  }

  const userIsPermitted = () => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink userIsPermitted'); }

    if (!user) return false;

    return permittedUsers.some(permittedUser => {
      for (let criterion in permittedUser) {
        if (user[lowerCaseFirstLetter(criterion)] !== permittedUser[criterion]) return false
      }

      if (linkText === 'Reports' && !showReports)
            return false;

      return true;
    });
  }

  const handleKeyDown = (e) => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink handleKeyDown'); }
    if (e.key === ' ' || e.key === 'Enter') {
      setShowFocus(true);
    }
  }

  const handleMouseDown = (e) => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink handleMouseDown'); }
    setFocusedByMouse(true);
    setShowFocus(false);
  }

  const handleTouchStart = (e) => {
    setFocusedByMouse(true);
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink handleTouchStart'); }
    setShowFocus(false);
  }

  const handleFocus = (e) => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink handleFocus'); }
    setShowFocus(!focusedByMouse);
    setFocusedByMouse(false);

  }

  const handleBlur = (e) => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink handleBlur'); }
    setShowFocus(false);
    setFocusedByMouse(false);
  }

  const toggleExpanded = () => {
    if (logComponent('MobileMenuLink')) { console.debug('MobileMenuLink toggleExpanded'); }
    setExpanded(!expanded);
  }



  return (
    userIsPermitted() &&
    <li key={outerLiKey} className={`Mobile-Menu-Link Mobile-Menu-Link__level-${level}`}>
      <button
        ref={setButtonRef}
        className={'Mobile-Menu-Link__button' + (showFocus ? ' Mobile-Menu-Link__button--show-focus' : '')}
        onKeyDown={handleKeyDown}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
        onBlur={handleBlur}
        onClick={isLink ? select : toggleExpanded}
        onFocus={handleFocus}
        data-target={linkText}>
        <div className="Mobile-Menu-Link__icon-container">
          {
            linkIcon &&
            <FontAwesomeIcon
              icon={linkIcon}
              className="Mobile-Menu-Link__icon" />
          }
        </div>
        <span className="Mobile-Menu-Link__text">
          {linkText}
          {
            (((linkText === "Administration" || linkText === "Organizations") && stagedOrganizationCount) || (linkText === "Messages" && messageCount > 0)) &&
            <FontAwesomeIcon className="Mobile-Menu-Link__badge-parent" icon="circle" size="sm" />
          }
          {
            linkText === 'New & Updated' && stagedOrganizationCount > 0 &&
            <span className="Mobile-Menu-Link__badge">{stagedOrganizationCount}</span>
          }
        </span>

        {
          !isLink &&
          <span className="Mobile-Menu-Link__toggle-icon-container">
            <FontAwesomeIcon
              icon="plus"
              className={'Mobile-Menu-Link__toggle-icon' + (expanded ? ' Mobile-Menu-Link__toggle-icon--expanded' : '')} />
          </span>
        }
      </button>
      {
        subLinks &&
        subLinks.length > 0 &&
        <ul className={'Mobile-Menu-Link__links' + (expanded ? ' Mobile-Menu-Link__links--expanded' : '')}>
          {
            subLinks.map(link =>
              <MobileMenuLink
                key={link.linkText}
                level={level + 1}
                linkAncestors={linkAncestors.concat(linkText)}
                permittedUsers={link.permittedUsers}
                user={user}
                linkText={link.linkText}
                linkIcon={link.linkIcon}
                linkPath={link.linkPath}
                subLinks={link.subLinks}
                showFocus={showFocus}
                stagedOrganizationCount={stagedOrganizationCount}
                messageCount={messageCount}
                lastReload={lastReload}
                showReports={showReports}
                onSelect={onSelect} />
            )
          }
        </ul>
      }
    </li>
  );
}